import Hieraf1 from '../../../Media/Fasilitas BSD/Hiera/Hiera (1).webp'
import Hieraf2 from '../../../Media/Fasilitas BSD/Hiera/Hiera (2).webp'
import Hieraf3 from '../../../Media/Fasilitas BSD/Hiera/Hiera (3).webp'
import Hieraf4 from '../../../Media/Fasilitas BSD/Hiera/Hiera (4).webp'




const Hierafimages =[
Hieraf1,Hieraf2,Hieraf3,Hieraf4
]

export default Hierafimages;